import { Card, CardContent, CardHeader } from '@/components/ui/Card';
import { Checkbox } from '@/components/ui/Checkbox';
import { useWizardStore } from '../lib/wizard-store';
import type { ChannelId } from '../lib/wizard-store';

export function W1_ChannelsStrategy() {
  const {
    channels_enabled,
    mail_then_call_fallback,
    formfill_runs_in_parallel,
    abandon_if_nothing,
    setChannels,
    setMailThenCallFallback,
    setFormfillRunsInParallel,
    setAbandonIfNothing,
  } = useWizardStore();

  const toggle = (ch: ChannelId) => {
    if (channels_enabled.includes(ch)) {
      setChannels(channels_enabled.filter((c) => c !== ch));
    } else {
      setChannels([...channels_enabled, ch]);
    }
  };

  const hasMail = channels_enabled.includes('mail');
  const hasCall = channels_enabled.includes('call');
  const hasFormfill = channels_enabled.includes('formfill');
  const hasLinkedInOutreach = channels_enabled.includes('linkedin_outreach');

  return (
    <Card>
      <CardHeader
        title="Channels & stratégie"
        subtitle="Canaux que le Dispatcher peut activer pour cette campagne et règles de fallback entre canaux."
      />
      <CardContent className="space-y-6">
        <div className="space-y-4" data-testid="channels-section">
          <Checkbox
            id="ch-mail"
            label="Email"
            description="Séquence d'emails outbound via le mail provider configuré ci-dessous"
            checked={hasMail}
            onChange={() => toggle('mail')}
          />
          <Checkbox
            id="ch-call"
            label="Call"
            description="Push des leads enrichis dans bigcall pour appel humain par les agents"
            checked={hasCall}
            onChange={() => toggle('call')}
          />
          <Checkbox
            id="ch-formfill"
            label="Form-fill"
            description="Soumission automatique du formulaire de contact des sites prospects"
            checked={hasFormfill}
            onChange={() => toggle('formfill')}
          />
          <Checkbox
            id="ch-linkedin-outreach"
            label="LinkedIn Outreach"
            description="Prospection LinkedIn via agents OpenOutreach connectés depuis le cockpit Outreach"
            checked={hasLinkedInOutreach}
            onChange={() => toggle('linkedin_outreach')}
          />
        </div>

        <hr className="border-brand-border" />

        <div className="space-y-4" data-testid="fallback-section">
          <Checkbox
            id="fb-mail-call"
            label="Fallback call après séquence email sans réponse"
            description="Si activé : si la séquence email se termine sans reply, le lead est routé vers le canal call."
            checked={mail_then_call_fallback}
            onChange={(e) => setMailThenCallFallback(e.target.checked)}
            disabled={!hasMail || !hasCall}
          />
          <Checkbox
            id="fb-formfill-parallel"
            label="Form-fill en parallèle de l'email"
            description="Si activé : le form-fill s'exécute pendant la séquence email, sans attendre la fin."
            checked={formfill_runs_in_parallel}
            onChange={(e) => setFormfillRunsInParallel(e.target.checked)}
            disabled={!hasMail || !hasFormfill}
          />
          <Checkbox
            id="fb-abandon"
            label="Abandonner le lead si aucun canal n'est applicable"
            description="Si activé : un lead sans email ni téléphone ni form_url est ignoré plutôt que mis en erreur."
            checked={abandon_if_nothing}
            onChange={(e) => setAbandonIfNothing(e.target.checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
}
